module.exports = __webpack_public_path__ + "static/weselove-logo-766e864f1c205e7d5493b1df61e22320.svg";